var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ce-sub-nav-item-info"},[_c('h2',{staticClass:"ce-sub-nav-item-info__headline m-0 mb-1 fs-16"},[_vm._v(_vm._s(_vm.headline))]),_c('p',{staticClass:"m-0"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }